import React, { useContext } from "react";
import { CardMedia, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles, useTheme } from "@mui/styles";
import { FaMicrosoft } from "react-icons/fa";
import { vapidKey, instance as firebaseInstance } from "../utils/Firebase";
import * as messaging from "firebase/messaging";
import { useSnackbar } from "notistack";
import { useMutation } from "@apollo/client";
import Dark from "../assets/logo-dark.svg";
import Light from "../assets/logo-white.svg";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../utils/MSALConfig";
import { IPublicClientApplication } from "@azure/msal-browser";
import useDarkMode from "../hooks/useDarkMode";
import DebouncedButton from "../components/DebounceButton";
import { ADD_FIREBASE_TOKEN } from "../graphql/Firebase.graphql";
import { AuthContext } from "../contexts/AuthProvider";
const useStyles = makeStyles((theme: any) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  media: {
    paddingTop: "30%", // 16:9,
  },
  card: {
    margin: "0 auto",
    padding: 20,
    minWidth: 300,
    width: 350,
  },
  cardItem: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 15,
    marginTop: 10,
    width: "100%",
    paddingTop: 60,
    paddingBottom: 40,
  },
}));

const Login = () => {
  const classes = useStyles();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { isDarkMode } = useDarkMode();
  const theme = useTheme<any>();
  const { instance, inProgress, accounts } = useMsal();
  const { setToken, setRole } = useContext(AuthContext);

  function handleLogin(instance: IPublicClientApplication) {
    instance
      .loginPopup(loginRequest)
      .then(async (res) => {
        const account = res.account;

        localStorage.setItem(
          "user_id",
          (res.account?.idTokenClaims as any).oid
        );
        localStorage.setItem("name", (res.account as any).name);
        localStorage.setItem("token", res.idToken);
        setToken(res.idToken);
        localStorage.setItem("exp", (res.idTokenClaims as any).exp)

        instance.setActiveAccount(account);
        let roles: string[] = (res.account?.idTokenClaims as any).groups?.map(
          (group: string) => {
            switch (group) {
              case "9bc72520-4586-4bef-b0fd-10e292b9e192":
                localStorage.setItem(
                  "role",
                  "9bc72520-4586-4bef-b0fd-10e292b9e192"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "planner");
                return "planner";
              case "a464ea24-01fc-43ec-a659-6027f67aaa44":
                localStorage.setItem(
                  "role",
                  "a464ea24-01fc-43ec-a659-6027f67aaa44"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "hulpverlener");
                return "hulpverlener";
              case "5db049d6-84a8-4fbd-9aee-2001bf617b26":
                localStorage.setItem(
                  "role",
                  "5db049d6-84a8-4fbd-9aee-2001bf617b26"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "team_coordinator");
                return "team_coordinator";
                case "352157d6-4b30-459f-b90e-cd9e87ebcf36":
                localStorage.setItem(
                  "role",
                  "352157d6-4b30-459f-b90e-cd9e87ebcf36"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "planner");
                return "planner";
              case "9457bebf-1680-43c4-9d8a-97ade9bed615":
                localStorage.setItem(
                  "role",
                  "9457bebf-1680-43c4-9d8a-97ade9bed615"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "hulpverlener");
                return "hulpverlener";
              case "da45c5e5-454e-409b-a37e-8c6d43beb03c":
                localStorage.setItem(
                  "role",
                  "da45c5e5-454e-409b-a37e-8c6d43beb03c"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "team_coordinator");
                return "team_coordinator";
                case "be3fa6fd-2cc7-4f4f-b542-0de5c56cc7f1":
                localStorage.setItem(
                  "role",
                  "be3fa6fd-2cc7-4f4f-b542-0de5c56cc7f1"
                );
                setRole(group);

                localStorage.setItem("role_pretty", "read_only");
                return "read_only";
            }
          }
        );

        // Get the only active role
        let role = roles.find((role) => role);
        try {
          const fbaseToken = await messaging.getToken(firebaseInstance, {
            vapidKey,
          });

          if (fbaseToken) {
            await uploadToken({
              context: {
                headers: {
                  authorization: `Bearer ${res.idToken}`,
                },
              },
              variables: {
                token_id: fbaseToken,
              },
            });
          }
        } catch (error) {
          console.log(error);
        }

        return role;
      })
      .then((res) => {
        switch (res) {
          case "planner":
            navigate("/allteams");
            break;
          case "hulpverlener":
            navigate("/caseload");
            break;
          case "team_coordinator":
            navigate("/teams");
            break;
          case "read_only":
            navigate("/allteams");
            break;
        }
      })
      .catch((e: any) => {
        console.error(e);
      });
  }

  const [uploadToken, { data: tokenData, loading: tokenLoading }] = useMutation(
    ADD_FIREBASE_TOKEN,
    {
      onCompleted: (data) => {
        enqueueSnackbar("Succesfully added token", { variant: "success" });
      },
      onError: (error) => {
        enqueueSnackbar(error, { variant: "error" });
      },
    }
  );

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        backgroundColor: theme.palette.primary.main,
      }}
    >
      <Card className={classes.card}>
        <CardMedia
          style={{
            width: "100%",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
          className={classes.media}
        // image={isDarkMode ? Light : Dark}
        />
        <form className={classes.cardItem}>
          <DebouncedButton
            startIcon={<FaMicrosoft />}
            size="medium"
            debounceTime={500}
            variant="contained"
            disabled={false}
            loading={false}
            onClick={() => handleLogin(instance)}
          >
            Inloggen
          </DebouncedButton>
        </form>
      </Card>
    </div>
  );
};

export default Login;
